import { merge, isEmpty, isNull } from 'lodash';
import { FILTER } from '../../constants/actionTypes';
import serializeUrl from '../../utils/serialize_url';
import { routes } from '../../constants/config';
import { getSharedParams } from '../shared/utils';

export const initialState = {
  page: 1,
  query: '',
  creator: null,
  instructor: null,
  pastOrUpcoming: null,
  sort: {
    column: 'date_updated',
    direction: 'desc',
  },
  perPage: 10,
};

const getParams = ({
  query,
  page,
  sort,
  perPage,
  instructor,
  pastOrUpcoming,
  creator,
}) => {
  const params = getSharedParams({ page, query, sort, perPage, initialState });
  if (instructor !== 'any' && !isNull(instructor)) {
    params.instructor = instructor;
  }
  if (!isNull(pastOrUpcoming)) {
    params.pastOrUpcoming = pastOrUpcoming;
  }
  if (creator !== 'any' && !isNull(creator)) {
    params.creator = creator;
  }
  return params;
};

const getNewState = (state, changes) => {
  const newState = { ...state, ...changes };
  const { query, instructor, creator, pastOrUpcoming } = newState;
  newState.isActive = [
    isEmpty(query),
    instructor === 'any' || isNull(instructor),
    creator === 'any' || isNull(creator),
    pastOrUpcoming === 'any' || isNull(pastOrUpcoming),
  ].some(filter => !filter);
  newState.page = (changes && changes.page) || 1;
  try {
    newState.url = serializeUrl(
      routes.IN_PERSON_TRAINING.EVENTS,
      getParams(newState),
    );
  } catch (error) {
    /* jquery may throw an error here on page load */
  }
  return newState;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FILTER.UPDATE.PAGE:
      return getNewState(state, {
        page: action.page,
      });

    case FILTER.UPDATE.QUERY:
      return getNewState(state, {
        query: action.query,
      });

    case FILTER.UPDATE.PER_PAGE:
      return getNewState(state, {
        perPage: action.perPage,
      });

    case FILTER.UPDATE.ALL:
      return getNewState(state, action.filter);

    case FILTER.UPDATE.CREATOR:
      return getNewState(state, { creator: action.id });

    case FILTER.UPDATE.INSTRUCTOR:
      return getNewState(state, { instructor: action.instructor });

    case FILTER.UPDATE.PAST_OR_UPCOMING: {
      let direction = 'desc';
      let sortOn = 'start_time';

      if (
        action.pastOrUpcoming ===
        t('in_person_training.events_dashboard.filtered_upcoming_events')
      ) {
        direction = 'asc';
      } else if (action.pastOrUpcoming === 'any') {
        sortOn = initialState.sort.column;
      }

      return getNewState(state, {
        sort: {
          column: sortOn,
          direction,
        },
        pastOrUpcoming: action.pastOrUpcoming,
      });
    }

    case FILTER.CLEAR:
      return getNewState(
        state,
        merge({}, initialState, {
          sort: state.sort,
          perPage: state.perPage,
        }),
      );

    case FILTER.SORT: {
      let direction = action.sortType === 'numeric' ? 'desc' : 'asc';
      if (state.sort.column === action.sortOn) {
        direction = state.sort.direction === 'asc' ? 'desc' : 'asc';
      }

      return getNewState(state, {
        sort: {
          column: action.sortOn,
          direction,
        },
      });
    }

    default:
      return getNewState(initialState, state);
  }
};
